import { createToastInterface } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export const toastOptions = {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  maxToasts: 10
};

// Singleton usable en cualquier lugar (Vuex, services, router, etc.)
export const toast = createToastInterface(toastOptions);
